import React from 'react';
import { CheckCircle } from 'lucide-react';
interface PurchaseNotificationProps {
  name: string;
  city: string;
  isVisible: boolean;
}
export function PurchaseNotification({
  name,
  city,
  isVisible
}: PurchaseNotificationProps) {
  return <div className={`fixed left-4 z-30 transform transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'} bottom-4`} data-id="element-10">
      <div className="rounded-lg p-3 flex items-center gap-2.5 max-w-[250px] md:max-w-xs backdrop-blur-sm" style={{
      background: 'rgba(18, 18, 18, 0.85)',
      border: '1px solid #FFD700'
    }} data-id="element-11">
        <div className="flex-shrink-0" data-id="element-12">
          <CheckCircle className="w-5 h-5" style={{
          color: '#FFD700'
        }} data-id="element-13" />
        </div>
        <div className="leading-tight" data-id="element-14">
          <p className="text-[11px] font-bold text-white" data-id="element-15">
            {name} de {city}
          </p>
          <p className="text-[10px] text-[#A1A1A1] mt-0.5" data-id="element-16">
            Acaba de adquirir el{' '}
            <span style={{
            color: '#FFD700',
            fontWeight: 'bold'
          }} data-id="element-17">
              Manual Oficio Eléctrico
            </span>
          </p>
          <p className="text-[9px] text-gray-500 mt-0.5" data-id="element-18">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}